<div class="loading-indicator" [class.custom-idp-loader]="isCustomIDP" [attr.data-loading-text]="'label.common.loading' | translate">
  @if (!isCustomIDP) {
    <custom-spinner margin="medium" label="{{ 'label.common.loading' | translate }}" mode="large"></custom-spinner>
  }

  @if (isCustomIDP) {
    <div class="custom-circular-loader">
      <div class="loader-container">
        <div class="circle-dots">
          <div class="dot dot-1"></div>
          <div class="dot dot-2"></div>
          <div class="dot dot-3"></div>
          <div class="dot dot-4"></div>
          <div class="dot dot-5"></div>
          <div class="dot dot-6"></div>
          <div class="dot dot-7"></div>
          <div class="dot dot-8"></div>
        </div>
      </div>
    </div>
  }
</div>
